/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type RewardApprovalBehavior = typeof RewardApprovalBehavior[keyof typeof RewardApprovalBehavior];


export const RewardApprovalBehavior = {
  BySystem: 'BySystem',
  ByCompanyManagementUser: 'ByCompanyManagementUser',
  ByEmployee: 'ByEmployee',
  DeclineByCompanyManagementUser: 'DeclineByCompanyManagementUser',
  DeclineByEmployee: 'DeclineByEmployee',
} as const;
